export default __webpack_public_path__ + "static/satellite-f05bc614e92346d148fb8efd569091a2.webp";